module.exports = __webpack_public_path__ + "img/visitors.984af6f7.svg";